import { API_URLS } from './api-urls';
/** This file can be replaced during build by using the `fileReplacements` array.
* `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
* The list of file replacements can be found in `angular.json`.
*/
export const environment = {
  name: 'staging',
  production: false,
  firebase: {
    apiKey: 'AIzaSyATJLhlswzu0dRFoWfP-Xcp4G_pE_Kzlpk',
    authDomain: 'ketto-login.firebaseapp.com',
    databaseURL: 'https://ketto-login.firebaseio.com',
    projectId: 'ketto-login',
    storageBucket: 'ketto-login.appspot.com',
    messagingSenderId: '154316787884'
  },
  gtm_id: 'GTM-PM8JK29V',
  gtm_ids: {
    'childhelpfoundation': 'GTM-K25VCW5',
    'donateforhealth': 'GTM-PM8JK29V',
    'indiahelpinghands': 'GTM-T7V68M9W',
    'savealifeindia': 'GTM-PMM2V6M6',
    'givehopeindia': 'GTM-TF8T9XWH',
    'donatetochange': 'GTM-M47ZRCRD',
    'indianmessiah': 'GTM-NQ2DBFXH',
    'raiseforindia': 'GTM-5H43G9NW',
    'indiamedicalfund': 'GTM-P4TJ4WJ7',
    'givehelpindia': 'GTM-PGB38GTF',
    'giveforcare': 'GTM-P63KXPQ3',
    'ashaforlife': 'GTM-PVZMCC5B',
    'cureforcause': 'GTM-MRKRGRBL',
    'wellnessfunders': 'GTM-574CP5FS'
  },
  clevertap_id: 'TEST-84R-5W8-476Z',
  facebook_id: '287403324698248',
  facebook_pixel: '538031250815425',
  google_client_id: '154316787884-v1hbq46oa8g9vpfnt7m7s9b6i3cul0pc.apps.googleusercontent.com',
  google_client_id_one_tap: '1035507078055-g4qo9db9end019j57f1blo0tfr0m0qtm.apps.googleusercontent.com',
  vwo: '326437',
  bugsnag: 'e9ac81b71cbf1cef3225a069b2fcc3d4',
  sentry: 'ba67c8ca81c84819b7e31ebddd920831',
  sentryAccountId: '1365515',
  algolia: {
    key: 'f8545d597bc150f5b32410b350cb2bc0',
    id: 'Q2WBPSP0YD',
    index: 'fundraiser_dev',
    disease: {
      index: 'dev_diseases',
      not_listed: 1820
    },
    hospital: {
      index: 'dev_hospitals',
      not_listed: 804783,
      not_admitted: 804784,
      no_hospitalisation_required: 804785
    }
  },
  meilisearch: {
    host: 'https://meilisearchdev.ketto.org',
    key: 'c2c6a47901b031f1d6fb89e66a227858ea42ddb3053bb746e32a990cdec751f0',
    index: 'fundraiser_dev',
    disease: {
      index: 'dev_diseases',
      not_listed: 1820
    },
    hospital: {
      index: 'dev_hospitals',
      not_listed: 804783,
      not_admitted: 804784,
      no_hospitalisation_required: 804785
    }
  },
  truecaller: {
    partnerKey: 'wWJP67524561d2a794a8fb52141cdc4f70987',
  },
  gcaptcha: '6Lemuy0UAAAAAAJL2gRKu1BzpYtg5oI8QJCT89bI',
  invisible_captcha: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  juspay: 'https://sandbox.juspay.in/',
  puhser_key: '5a179ea8cd27b83badfc',
  base_ref: '/new/',
  asset_base_ref: '',
  static_assets: 'https://static.ketto.org/',
  zoho_mail_medical: 'owk3jot5z_hfj8paj@parser.zohocrm.com',
  zoho_mail: '5jsam3p3a_byld1ab@parser.zohocrm.com',
  manage_domain: 'https://devmanage.ketto.org',
  sipretention_domain: 'https://devsip.ketto.org',
  microsoft_clarity: 'f5d5n1q3au',
  KETTO_URL: 'https://www.ketto.org',
  APP: {
    BASE_URL: typeof window !== 'undefined' && !window?.location?.origin.match('localhost') ? window.location.origin + '/api/' : 'https://devapis.ketto.org/api/',
    CORE_API: '',
    IMAGE_DOMAIN: 'https://d1odpswjdg60uv.cloudfront.net',
    GET_IP: 'third_party/iplocation',
    KETTO_DOMAIN_URL: 'https://dev2.ketto.org',
    DOMAIN_URL: '',
    API_URLS
  },
  health_first_campaign_id: 812634,
  health_first_ct: 'health-first-default-campaign'
};

/**
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
